import { isDevMode } from '@angular/core';
import { ActionReducerMap, MetaReducer } from '@ngrx/store';
import { CompaniesState } from '../app/features/companies/models/stock.model';
import * as fromDividends from '../app/features/companies/store/dividends/dividends.reducer';
import * as fromFinancialStatements from '../app/features/companies/store/financial-statements/financial-statements.reducer';
import * as fromHolders from '../app/features/companies/store/holders/holders.reducer';
import * as fromRatios from '../app/features/companies/store/ratios/ratios.reducer';
import * as fromSplits from '../app/features/companies/store/splits/splits.reducer';
import * as fromStocks from '../app/features/companies/store/stocks/stocks.reducer';
import { SectorsState } from '../app/features/sectors/models/sector.model';
import * as fromSectors from '../app/features/sectors/store/sectors.reducer';
import * as fromForecasts from '../app/features/companies/store/forecasts/forecasts.reducer';
import * as fromProperty from '../app/features/control-panel/store/property/property.reducer';
import * as fromTemplates from '../app/features/control-panel/store/templates/templates.reducer';
import { TemplateState } from '../app/features/control-panel/models/template.model';

export interface State {
  stocks: CompaniesState;
  sectors: SectorsState;
  financialStatements: fromFinancialStatements.FinancialStatementsState;
  ratios: fromRatios.RatiosState;
  dividends: fromDividends.DividendsState;
  holders: fromHolders.HoldersState;
  splits: fromSplits.SplitsState;
  forecasts: fromForecasts.ForecastsState;
  property: fromProperty.PropertyState;
  templates: TemplateState;
}

export const reducers: ActionReducerMap<State> = {
  stocks: fromStocks.stocksReducer,
  sectors: fromSectors.sectorsReducer,
  financialStatements: fromFinancialStatements.financialStatementsReducer,
  ratios: fromRatios.ratiosReducer,
  dividends: fromDividends.dividendsReducer,
  holders: fromHolders.holdersReducer,
  splits: fromSplits.splitsReducer,
  forecasts: fromForecasts.forecastsReducer,
  templates: fromTemplates.templatesReducer,
  property: fromProperty.propertyReducer,
};

export const metaReducers: MetaReducer<State>[] = isDevMode() ? [] : [];
